// ============================================================================
// ROOM CATEGORY ENDPOINTS
// ============================================================================
// Endpoint definitions for Room Category module

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

/**
 * Base path for room category endpoints (matches RoomCategoryController route)
 */
const BASE_PATH = '/RoomCategory';

/**
 * Room Category Endpoints
 */
export const roomCategoryEndpoints = {
  /**
   * Get all room categories (paginated)
   * GET /RoomCategory
   */
  list: () => buildEndpoint(BASE_PATH),

  /**
   * Get room category by ID
   * GET /RoomCategory/:id
   */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Get room category by code
   * GET /RoomCategory/code/:code
   */
  getByCode: (code: string) => buildEndpointWithParams(`${BASE_PATH}/code/:code`, { code }),

  /**
   * Create new room category
   * POST /RoomCategory
   */
  create: () => buildEndpoint(BASE_PATH),

  /**
   * Update room category
   * PUT /RoomCategory/:id
   */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Delete room category
   * DELETE /RoomCategory/:id
   */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Validate room category code uniqueness
   * GET /RoomCategory/validate/code/:code?propertyId=&excludeId=
   */
  validateCode: (code: string) =>
    buildEndpointWithParams(`${BASE_PATH}/validate/code/:code`, { code }),

  /**
   * Validate room category name uniqueness
   * GET /RoomCategory/validate/name/:name?propertyId=&excludeId=
   */
  validateName: (name: string) =>
    buildEndpointWithParams(`${BASE_PATH}/validate/name/:name`, { name }),
} as const;

/**
 * Export endpoints
 */
export default roomCategoryEndpoints;
